import { DateTime } from "luxon";
import { defaultDatePickerMinDate, defaultDatePickerMaxDate } from "../../Components/Form/datePickerBounds";

// Keep Redux values serializable while distinguishing invalid input from an
// intentionally empty optional date. Only validated values reach the API.
const invalidDateInput = "__invalid_date__";

export const serializeFormDateInput = (value) => {
  if (value == null) return null;
  return value.isValid ? value.toFormat("y/LL/dd") : invalidDateInput;
};

export const parseFormDateInput = (value) => {
  if (value == null || value === "") return null;
  if (DateTime.isDateTime(value)) return value;
  return typeof value === "string"
    ? DateTime.fromFormat(value, "y/LL/dd", { locale: "en" })
    : DateTime.invalid("invalid form date");
};

export const formDateError = (value) => {
  const date = parseFormDateInput(value);
  if (!date) return null;
  if (!date.isValid) return "error_invalid_date";
  // Match the picker's inclusive calendar-day bounds, ignoring time of day.
  const day = date.startOf("day");
  return day < defaultDatePickerMinDate || day > defaultDatePickerMaxDate
    ? "error_invalid_date"
    : null;
};

export const formDateRangeErrors = (from, to) => {
  const errors = {};
  if (formDateError(from)) errors.from = "error_invalid_date";
  if (formDateError(to)) errors.to = "error_invalid_date";
  const start = parseFormDateInput(from);
  const end = parseFormDateInput(to);
  if (start?.isValid && end?.isValid && start.startOf("day") > end.startOf("day")) {
    errors.to = "form_date_range_invalid";
  }
  return errors;
};

export const hasInvalidFormDates = (form, fields) => Boolean(
  formDateError(form.dueDate) || fields.some((field) =>
    field.type === "date" && Object.keys(formDateRangeErrors(field.from, field.to)).length > 0)
);
